import Vue from 'vue';


/**
 * Get all teacher schedule by teacher IDs
 * @param {*} teacherIds 
 * @param {*} activeOnly 
 * @returns 
 */
const fetchTeacherSchedulesByTeacherIds = async (teacherIds, activeOnly = true) => {
  const params = {
      size: 100000,
      teacher_ids: teacherIds ? teacherIds.join(',') : null,
      active_only: activeOnly
  };

  return await Vue.axios
      .get("/teacher-schedule/by-teacher-ids", { params })
      .then((resp) => {
          return resp.data.content;
      })
      .catch((error) => {
          throw error
      });
}



async function getScheduleExclusionDates(scheduleIds) {
  const params = {
    schedule_ids: scheduleIds ? scheduleIds.join(',') : null
  }

  let scheduleExclusionDates = []
  await Vue.axios.get('/teacher-schedule/excluded-dates', { params })
    .then(resp => {
      scheduleExclusionDates = resp.data;
    })
    .catch((error) => {
      throw error
    });

  return scheduleExclusionDates;
}

/**
 * Undo the cancellation of a teacher schedule occurrence
 * @param {number} scheduleId - The ID of the teacher's schedule
 * @param {string} scheduleDate - The date of the occurrence to undo cancellation (format: "yyyy-MM-dd")
 * @returns {Promise<void>}
 */
const undoCancelOccurrence = async (scheduleId, scheduleDate) => {
  const params = { schedule_date: scheduleDate };

  return await Vue.axios
      .put(`/teacher-schedule/undo-cancel-occurrence/${scheduleId}`, null, { params })
      .then(() => {
          // Success response handling
      })
      .catch((error) => {
          throw error;
      });
}

export {
  fetchTeacherSchedulesByTeacherIds,
  getScheduleExclusionDates,
  undoCancelOccurrence 
}
